const baseDomains = ['edreams', 'govoyages', 'opodo', 'travellink'];

const tlds = {
  edreams: [
    'ch',
    'co.kr',
    'co.uk',
    'com',
    'com.ar',
    'com.au',
    'com.mx',
    'com.tr',
    'cz',
    'de',
    'es',
    'fr',
    'gr',
    'hk',
    'in',
    'it',
    'jp',
    'ma',
    'net',
    'nl',
    'pe',
    'ph',
    'pt',
    'qa',
    'sa',
    'tw',
  ],
  govoyages: ['com'],
  opodo: [
    'at',
    'ch',
    'co.uk',
    'com',
    'com.au',
    'de',
    'dk',
    'es',
    'fi',
    'fr',
    'it',
    'nl',
    'no',
    'pl',
    'pt',
    'se',
  ],
  travellink: ['com', 'de', 'dk', 'fi', 'is', 'no', 'se'],
};

/**
 * Returns the list of registered domains
 * @type {string[]}
 */
export const registedDomains = baseDomains.flatMap(base =>
  tlds[base].map(tld => `privacy.${base}.${tld}`)
);
